import { useMutation } from '@tanstack/react-query';
import { API_AGGREGATOR_ACCEPT_DISCLOSURES } from 'src/api/aggregator-request-objects';
import { apiRequest } from 'src/api/request-handler';
import { AggregatorAcceptanceResponse } from 'src/interfaces/aggregator.interfaces';

export const useAggregatorAcceptDisclosures = () => {
  return useMutation({
    mutationFn: async ({ token, session_id, showOffers }: { token: string; session_id?: string; showOffers?: string }) => {
      const queryParams: { token: string; session_id?: string; showOffers?: string } = { token };
      if (session_id) {
        queryParams.session_id = session_id;
      }
      if (showOffers !== undefined && showOffers !== null) {
        queryParams.showOffers = showOffers;
      }
      const res = await apiRequest<AggregatorAcceptanceResponse>(API_AGGREGATOR_ACCEPT_DISCLOSURES, {
        query: queryParams,
      });
      return res;
    },
  });
};
